import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

/**
 * Message configuration with optional refresh button
 */
export interface FlashMessage {
  title: string;
  message: string;
  styleName?: string;
  button?: boolean;
}

@Component({
  selector: 'lib-flash-message',
  templateUrl: './lib-flash-message.component.html',
  styleUrls: ['./lib-flash-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LibFlashMessageComponent implements OnInit {
  @Input() title: string = '';
  // @Input() message: string = '';
  @Input() styleName: string = '';

  @Input() message: FlashMessage = {
    title: '',
    message: '',
    styleName: '',
  };

  /**
   * Emits when a refresh button in a message is clicked
   */
  @Output() buttonClicked = new EventEmitter<FlashMessage>();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {}

  /**
   * Handle refresh button click and emit event with message context
   * @param message The message containing the clicked button
   */
  onButtonClick(message: FlashMessage): void {
    if (message.button) {
      this.buttonClicked.emit(message);
    }
  }

  onMessageClick(event: MouseEvent): void {
    const link = (event.target as HTMLElement).closest('a');

    if (!link) {
      return;
    }

    const route = link.getAttribute('href');

    if (route) {
      event.preventDefault();
      this.router.navigate([route], {
        relativeTo: this.route,
      });
    }
  }
}
